<template>
  <div>
    <p v-if="isRereview || allowOrderReviewWithReadonly">
      <order-review-timer v-model="time"/>
    </p>
    <div style="margin-bottom: 13px;" v-if="!allowLiveOrderReview">
      <template v-if="orderDetail.locked || allowOrderReviewWithReadonly || allowUserModifyAnswer">
        <!--锁定审核-->
        <order-lock-button :locked="orderDetail.locked"
                           :id="orderDetail.orderid"
                           :lock-reason="orderDetail.lock_reason"/>
      </template>
      <template v-if="allowOrderReviewWithReadonly || allowUserModifyAnswer">
        <!--读取缓存-->
        <order-review-read-cache-button :order-id="orderDetail.orderid"
                                        :tpl-id="orderDetail.templatesnapshotid"/>
      </template>
    </div>
    <div>

      <div style="display: flex;gap: 10px;">
        <!--保存修改-->
        <order-save-answer-button
          v-if="allowUserModifyAnswer"
          :id="orderDetail.orderid"/>
        <!-- 复核审核质量 -->
        <ReviewAuditQualityButton
          :id="orderDetail.orderid"/>
      </div>

      <!-- 退单原因是否规范评价-->
      <ReturnOrderStandEvalButton style="margin: 5px 0;"></ReturnOrderStandEvalButton>

      <!--完成审核-->
      <order-review-finish-button
        v-if="allowOrderReviewWithReadonly && !allowLiveOrderReview"
        :salary="orderDetail.salary"
        :needGatherMarketPhoto="needGatherMarketPhoto"
        @pass="reviewOrderPass"
        @not-pass="reviewOrderNotPass"/>

      <!--一键审核-->
      <onekey-review-button
        v-if="allowOrderReviewWithReadonly"
        :salary="orderDetail.salary"
        :needGatherMarketPhoto="needGatherMarketPhoto"
        :error-messages="errorMessages"
        @pass="reviewOrderPass"
        @not-pass="reviewOrderNotPass"/>

      <!--复审-->
      <order-rereview-button
        v-if="isRereview"
        :components="{ customSalary: true }"
        :salary="orderDetail.salary"
        @pass="RereviewOrderPass"
        @not-pass="reviewOrderNotPass"/>

      <!-- 强制完成、重置 -->
      <order-reset-finish-button
        :components="{ customSalary: true }"
        :orderDetail="orderDetail"/>

      <!--   找回已关闭状态下的工单证据   /-->
      <OrderCompressEvidenceButton v-if="orderDetail.status + '' === '-1'"
                                   :orderDetail="orderDetail"/>

      <!-- 前往KeyIn按钮 -->
      <order-key-in-image-group-button v-if="orderDetail.status === '5'"
                                       :orderId="orderDetail.orderid"
                                       :customer-id="orderDetail.customerid"
                                       style="margin-top: 13px"/>
    </div>

    <recommend-order ref="RecommendOrder"
                     :recommendOrderCount="recommendOrderCount"
                     :orderDetail="orderDetail"></recommend-order>
  </div>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'
import OrderReviewTimer from '@views/order-review/components/OrderReviewTimer'
import OrderReviewFinishButton from '@views/order-review/components/OrderReviewFinishButton'
import OrderSaveAnswerButton from '@views/order-review/components/OrderSaveAnswerButton'
import OnekeyReviewButton from '@views/order-review/components/OnekeyReviewButton'
import OrderRereviewButton from '@views/order-review/components/OrderRereviewButton'
import OrderResetFinishButton from '@views/order-review/components/OrderResetFinishButton'
import OrderLockButton from '@views/order-review/components/OrderLockButton'
import OrderReviewReadCacheButton from '@views/order-review/components/OrderReviewReadCacheButton'
import RecommendOrder from '@views/order-review/components/RecommendOrder'
import OrderKeyInImageGroupButton from '@views/order-review/components/OrderKeyInImageGroupButton.vue'
import OrderCompressEvidenceButton from '@views/order-review/components/OrderCompressEvidenceButton.vue'
import ReviewAuditQualityButton from '@views/order-review/components/ReviewAuditQualityButton.vue'
import ReturnOrderStandEvalButton from '@views/order-review/components/ReturnOrderStandEvalButton.vue'

export default {
  inject: ['page'],
  components: {
    ReturnOrderStandEvalButton,
    OrderKeyInImageGroupButton,
    OrderReviewReadCacheButton,
    OrderCompressEvidenceButton,
    OrderLockButton,
    OrderRereviewButton,
    OrderResetFinishButton,
    OnekeyReviewButton,
    OrderSaveAnswerButton,
    OrderReviewFinishButton,
    OrderReviewTimer,
    RecommendOrder,
    ReviewAuditQualityButton,
  },
  mixins: [],
  props: {},
  data () {
    return {
      time: 0,
      recommendOrderCount: {
        batch: {
          market: null,
          total: null,
          user: null
        },
        project: {
          market: null,
          total: null,
          user: null,
        },
        note: null
      }
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      errorMessages: state => state.orderReview.errorMessages,
      storeCollection: state => state.storeCollection,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowOrderReview',
      'allowUserModifyAnswer',
      'allowLiveOrderReview'
    ]),
    isRereview () {
      return this.orderDetail.status === '40'
    },
    needGatherMarketPhoto () {
      // 题目中没有收集门头照的题目
      const title = _.get(this.page, 'questions[1].title')
      if (!title || !_.startsWith(title, '【到达】')) {
        return false
      }
      // 该题目没有所属门店
      if (!this.orderDetail.marketinfo) {
        return false
      }

      // 使用后端计算的值
      return this.orderDetail.needGatherMarketPhoto
    },
    allowOrderReviewWithReadonly () {
      return this.allowOrderReview && this.page.readonly !== 'on'
    }
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {
  },
  methods: {
    /**
     * 复审通过请求
     */
    RereviewOrderPass (data) {
      let params = {
        id: this.orderDetail.orderid,
        salary: data.salary,
        templateresultjson: JSON.stringify(QuestionReview().getRecoveryAnswers(this.page)),
        sec_consumed: this.time,
        review_message: data.message,
      }
      request.common('reviewClbOrderPass', params).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})
        this.$alert('已确认订单结果！', '审核成功', {type: 'success'})
      })
    },
    /**
     * 审核通过请求
     * params参数有更新时，需要同步更新 OrderAppealHandle.vue 中的 doOrderAppealPass 中的params
     */
    reviewOrderPass (data) {
      let answers = QuestionReview().getRecoveryAnswers(this.page)
      if (data.marketPhotoIndex !== null) {
        answers[1].marketPhotoIndex = data.marketPhotoIndex
      }
      let params = {
        id: this.orderDetail.orderid,
        salary: data.salary,
        templateresultjson: JSON.stringify(answers),
        sec_consumed: this.time,
        settle_detail: data.settle_detail,
        rank_score: data.rank_score,
        is_invalid_for_task_group: data.is_invalid_for_task_group,
      }
      request.common('reviewOrderPass', params).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})
        this.recommendOrderReview('已确认订单结果！')
      })
    },
    /**
     * 审核不通过请求
     */
    reviewOrderNotPass ({message, prolongTime}) {
      request.common('reviewOrderNotPass', {
        id: this.orderDetail.orderid,
        errormessage: message,
        specifiedEndTime: prolongTime,
        templateresultjson: JSON.stringify(QuestionReview().getRecoveryAnswers(this.page)),
        sec_consumed: this.time,
      }).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})

        this.recommendOrderReview('订单已退回！')
      })
    },
    /**
     * 推荐下一个工单
     */
    recommendOrderReview (note) {
      // 判断任务类型是否为23(宴席类)，如果是则调用 getUnauditedBanquetOrdersCount 接口
      const apiName = this.orderDetail.type + '' === '23' ? 'getUnauditedBanquetOrdersCount' : 'getUnauditedOrdersCount'
      request.common(apiName, {
        batchid: this.orderDetail.batchid,
        projectid: this.orderDetail.projectid,
        marketid: this.orderDetail.marketid,
        provinceid: this.orderDetail.provinceid,
        userid: this.orderDetail.userid,
        orderid: this.orderDetail.orderid,
        templateid: this.orderDetail.templateid
      }).then((data) => {
        this.recommendOrderCount = data.data
        this.recommendOrderCount.note = note
        if (this.isNotZero()) {
          this.$refs.RecommendOrder.open(data.data)
        } else {
          this.$alert(note, '已无更多待审核订单', {type: 'success'})
        }
      })
    },
    /**
     * 判断是否推荐里的数字都是0
     * @returns {boolean}
     */
    isNotZero () {
      for (let data in this.recommendOrderCount) {
        if (data === 'batch' || data === 'project') {
          for (let num in this.recommendOrderCount[data]) {
            if (this.recommendOrderCount[data][num] > 0) {
              return true
            }
          }
        }
      }
      return false
    }
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewSidebarPanel/OrderReviewButtons.vue